//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductsFoundersCardItemBody from './ProductsFoundersCardItemBody';

export default {
  components: {
    ProductsFoundersCardItemBody,
  },
  props: {
    posts: {
      type: Array,
      required: true,
    },
    links: {
      type: Array,
      default: () => ([]),
    },
    postIndex: {
      type: Number,
      default: 0,
    },
    highlightSelectedPost: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasLinks() {
      return !!this.links?.length;
    },
  },
  methods: {
    clickPost(index) {
      this.$emit('click-post', index);
    },
  },
};
